import { uuidv4 } from "./jdcToGr";
import { DEFAULT_RELATIONSHIP_TYPE, RELATION_TYPE } from "../constants";
import { assemblyForeignKey, associationDefinition } from "./editorUtils";
import { cloneDeep } from "lodash";
import { START } from "./nodeTypes";
export const customOnLinkComplete = (props, callBack) => {
  const {
    linkId,
    fromNodeId,
    fromPortId,
    toNodeId,
    toPortId,
    config = {},
  } = props;
  return (chart) => {
    if (
      !config.readonly &&
      (config.validateLink ? config.validateLink({ ...props, chart }) : true) &&
      [fromNodeId, fromPortId].join() !== [toNodeId, toPortId].join()
    ) {
      const tmpLink = chart.links[linkId];
      tmpLink.to = {
        nodeId: toNodeId,
        portId: toPortId,
      };
      if (chart.mode && chart.mode === "MR") {
        const nodeFromKey = tmpLink.from.nodeId;
        const nodeToKey = tmpLink.to.nodeId;
        const fromNode = chart.nodes[nodeFromKey];
        const toNode = chart.nodes[nodeToKey];
        const fromPrimaryKey = fromNode.properties.attributes.find(
          (o) => o.primaryKey === true
        );
        const toPrimaryKey = toNode.properties.attributes.find(
          (o) => o.primaryKey === true
        );
        // identifica las llaves a utilizar
        const fromKeys = associationDefinition(
          DEFAULT_RELATIONSHIP_TYPE[0],
          fromNode.properties.name,
          toNode.properties.name,
          fromPrimaryKey.name,
          toPrimaryKey.name,
          true //visto desde el nodo de origen
        );
        const toKeys = associationDefinition(
          DEFAULT_RELATIONSHIP_TYPE[1],
          fromNode.properties.name,
          toNode.properties.name,
          fromPrimaryKey.name,
          toPrimaryKey.name,
          false // visto del nodo de llegada
        );
        //
        tmpLink.properties = {
          connectionsProps: {
            model: toNode.properties.name,
            target: fromKeys.target,
            origin: fromKeys.origin,
            associationType: fromKeys.relation,
          },
          secondAssociation: {
            [nodeToKey]: {
              model: toNode.properties.name,
              target: {
                model: fromNode.properties.name,
                id: nodeFromKey,
                associationType: toKeys.relation,
                target: toKeys.target,
                origin: toKeys.origin,
              },
            },
          },
        };
        // se agregan las llaves al modelo
        const createKey = (keys, node, type) => {
          if (keys.relation === RELATION_TYPE.HAS_MANY_RELATION) {
            //se puede mejorar. es poco flexible
            if (node.properties && node.properties.attributes) {
              node.properties.attributes.push(
                assemblyForeignKey(keys.origin, type)
              );
            }
          }
        };
        createKey(fromKeys, fromNode, fromPrimaryKey.type);
        createKey(toKeys, toNode, toPrimaryKey.type);
      }
      chart.links[tmpLink.id] = tmpLink;
      if (typeof callBack === "function") {
        const data = callBack(tmpLink);
        if (data) {
          for (const key in data) {
            chart[key] = data[key];
          }
        }
      }
    } else {
      delete chart.links[linkId];
    }
    return chart;
  };
};

export const customOnCanvasDrop = (props, callBack) => (chart) => {
  const { config, data, position } = props;
  const id = uuidv4();
  const newNode = {
    id,
    position:
      config && config.snapToGrid
        ? {
            x: Math.round(position.x / 20) * 20,
            y: Math.round(position.y / 20) * 20,
          }
        : { x: position.x, y: position.y },
    orientation: data.orientation || 0,
    type: data.type,
    ports: data.ports,
    properties: data.properties,
  };

  chart.nodes[id] = newNode;
  if (typeof callBack === "function") {
    const data = callBack(newNode);
    if (data) {
      for (const key in data) {
        chart[key] = data[key];
      }
    }
  }
  return chart;
};
export const customOnDeleteKey = () => (chart) => {
  if (chart.selected.type === "node" && chart.selected.id) {
    const node = chart.nodes[chart.selected.id];
    if (node.type !== START) {
      // Delete the connected links
      Object.keys(chart.links).forEach((linkId) => {
        const link = chart.links[linkId];
        if (link.from.nodeId === node.id || link.to.nodeId === node.id) {
          //se eliminan las claves foraneas del nodo a eliminar
          //para esto se verifican los link con origen en el nodo actual
          if (chart.mode === "MR" && link.from.nodeId === node.id) {
            chart.nodes[link.from.nodeId] = updateAttributes(
              chart.nodes[link.to.nodeId],
              link.properties.secondAssociation[link.to.nodeId].target.origin
            );
          }
          delete chart.links[link.id];
        }
      });
      // Delete the node
      delete chart.nodes[chart.selected.id];
    }
  } else if (chart.selected.type === "link" && chart.selected.id) {
    //seccion agregada para actualizar las depencias
    if (chart.mode === "MR") {
      const link = chart.links[chart.selected.id];
      const { properties } = link;
      if (
        properties.connectionsProps &&
        properties.connectionsProps.associationType ===
          RELATION_TYPE.HAS_MANY_RELATION
      ) {
        chart.nodes[link.from.nodeId] = updateAttributes(
          chart.nodes[link.from.nodeId],
          properties.connectionsProps.origin
        );
      }
      if (
        properties.secondAssociation &&
        properties.secondAssociation[link.to.nodeId] &&
        properties.secondAssociation[link.to.nodeId].target &&
        properties.secondAssociation[link.to.nodeId].target.associationType ===
          RELATION_TYPE.HAS_MANY_RELATION
      ) {
        chart.nodes[link.to.nodeId] = updateAttributes(
          chart.nodes[link.to.nodeId],
          properties.secondAssociation[link.to.nodeId].target.origin
        );
      }
    }
    delete chart.links[chart.selected.id];
  }
  if (chart.selected) {
    chart.selected = {};
  }
  return chart;
};
export const customOnDragNode = ({ config, event, data, id }) => (chart) => {
  const nodechart = chart.nodes[id];
  const tmp = cloneDeep(chart); // clone el state pero el problema es que no recalcula la posicion de los link
  // creo que seria una buena idea tratar de usar redux
  if (nodechart) {
    tmp.nodes[id] = {
      ...nodechart,
      position:
        config && config.snapToGrid
          ? { x: Math.round(data.x / 20) * 20, y: Math.round(data.y / 20) * 20 }
          : { x: data.x, y: data.y },
    };
  }
  return tmp;
};
const updateAttributes = (node, key) => {
  const newAtt = node.properties.attributes;
  node.properties.attributes = newAtt.filter((o) => o.name !== key);
  return node;
};
